exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.capcitaciones-encabezado[data-v-278a5f60] {\n  font-weight: 600;\n  color: rgb(88, 85, 85);\n}\n.modulo-capacitaciones[data-v-278a5f60] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  gap: 20px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-top: 20px;\n}\n.capacitaciones__btn button[data-v-278a5f60] {\n  padding: 25px;\n  border-radius: 10px;\n  text-transform: none;\n  width: 300px;\n}\n.btn--activate[data-v-278a5f60] {\n  background-color: #ffe800 !important;\n}\n", ""]);

// exports
